import React, { FC } from 'react';

interface SvgIconProps {
  className?: string;
  size?: number;
  viewBox?: string;
  fill?: string;
  strokeDashOffset?: number;
}

export type IconProps = Omit<SvgIconProps, 'viewBox'>;

const BaseIcon: FC<SvgIconProps> = ({ children, className, size, viewBox, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    height={size}
    className={className}
    fill={fill}
  >
    {children}
  </svg>
);

export default BaseIcon;
